import { emDash, lessThanOneCent } from './constants';

type ValueInput = string | number | undefined | null;
type FormatType = 'currency' | 'currencyNoDecimal' | 'asset' | 'integer' | 'percent';
type FractionDigitsOptions = Pick<Intl.NumberFormatOptions, 'minimumFractionDigits' | 'maximumFractionDigits'>;

export const formatNumber = (value: ValueInput, format: FormatType, options?: FractionDigitsOptions) => {
  const num = typeof value === 'string' ? Number.parseFloat(value) : value;
  if (num === undefined || num === null || Number.isNaN(num)) {
    return emDash;
  }

  switch (format) {
    case 'currency':
      if (num < 0.01 && num > 0) {
        return lessThanOneCent;
      }
      return new Intl.NumberFormat(navigator.language, {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: options?.minimumFractionDigits,
        maximumFractionDigits: options?.maximumFractionDigits,
      }).format(num);
    case 'asset':
      if (num < 0.001 && num > 0) {
        return '< .001';
      }
      return new Intl.NumberFormat(navigator.language, {
        minimumFractionDigits: options?.minimumFractionDigits ?? 3,
        maximumFractionDigits: options?.maximumFractionDigits ?? 3,
      }).format(num);
    case 'integer':
      if (num < 1 && num > 0) {
        return '< 1';
      }
      return new Intl.NumberFormat(navigator.language, { maximumFractionDigits: 0 }).format(num);
    case 'percent':
      if (num < 0.1 && num > 0) {
        return '< 0.1%';
      }
      return `${new Intl.NumberFormat(navigator.language, {
        minimumFractionDigits: options?.minimumFractionDigits ?? 1,
        maximumFractionDigits: options?.maximumFractionDigits ?? 1,
      }).format(num)}%`;
    case 'currencyNoDecimal':
      if (num < 1 && num > 0) {
        return '< $1';
      }
      return new Intl.NumberFormat(navigator.language, {
        minimumFractionDigits: options?.minimumFractionDigits ?? 0,
        maximumFractionDigits: options?.maximumFractionDigits ?? 0,
        style: 'currency',
        currency: 'USD',
      }).format(num);
    default:
      throw new Error(`Unhandled format: ${format}`);
  }
};
